import cnBind from "classnames/bind";
import { Modal } from "@/components/_Modals/Modal";
import { ModalFeedBack } from "@/components/_Modals/ModalFeedBack";
import type { GetPortfolioDto } from "@/entities/types/entities";
import { API_BASE } from "@/shared/constants/private";
import { useResizeContext } from "@/shared/context/WindowResizeProvider";
import { useBooleanState } from "@/shared/hooks";
import { Button } from "@/shared/ui/Button";
import { CustomImage } from "@/shared/ui/CustomImage";
import styles from "./ModalCaseBlock.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    isOpen: boolean;
    onClose: () => void;
    item: GetPortfolioDto;
};

export const ModalCaseBlock = ({ isOpen, onClose, item }: Props) => {
    const { isMobile } = useResizeContext();
    const [isOpenFeed, open, close] = useBooleanState(false);

    const imageSrc = item?.pictureId ? `${API_BASE}/picture/${item.pictureId}` : "";
    const itemTitle = item?.title || "";
    const itemDescription = item?.description || "";

    return (
        <Modal
            className={cx("modal-case", { isMobile })}
            maxWidth="880px"
            onClose={onClose}
            isOpen={isOpen}
            dismissableMask={true}
        >
            <div className={cx("wrapper", { isMobile })}>
                <div className={cx("content")}>
                    <div className={cx("info")}>
                        <div className={cx("title")}>
                            <h4>{itemTitle}</h4>
                            <span>{itemDescription}</span>
                        </div>
                    </div>

                    {imageSrc && (
                        <div className={cx("image-container")}>
                            <CustomImage className={cx("image")} src={imageSrc} alt={itemTitle} fill priority />
                        </div>
                    )}
                </div>
                <div className={cx("footer")}>
                    <h3>Хотите так же?</h3>
                    <Button onClick={open} className={cx("submit-button")} label="Заказать звонок" />
                </div>
            </div>
            <ModalFeedBack isOpen={isOpenFeed} onClose={close} />
        </Modal>
    );
};
